import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL
export const ICARD_REQUESTS_REPORT_URL = `${API_URL}/icard-requests`

export const service = {
  getIcardRequestsReport: (params: ParamsModel) => {
    return axios.get(ICARD_REQUESTS_REPORT_URL, {params})
  },
  getIcardRequestsReportDetail: (md5Id: string) => {
    return axios.get(`${ICARD_REQUESTS_REPORT_URL}/${md5Id}`)
  },
  updateIcardRequestStatus: (md5Id: string, status: string) => {
    return axios.patch(`${ICARD_REQUESTS_REPORT_URL}/${md5Id}/status`, {status})
  },
}
